"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.termsContractsByCustomerId = void 0;
exports.termsContractsByCustomerId = (state = {}, action = {}) => {
    switch (action.type) {
        case 'TERMS_CONTRACTS_GET_BY_CUSTOMER_RECEIVE':
        case 'TERMS_CONTRACTS_AGREE_BY_CUSTOMER_RECEIVE':
            const newTerms = action.payload.contracts.map((c) => c.terms_id);
            const keepContracts = (state[action.payload.customerId] || []).filter((c) => !newTerms.includes(c.terms_id));
            return Object.assign(Object.assign({}, state), { [action.payload.customerId]: [...keepContracts, ...action.payload.contracts] });
        default:
            return state;
    }
};
//# sourceMappingURL=reducer.js.map